import { render, staticRenderFns } from "./SmsTemplateList.vue?vue&type=template&id=40fb1e98"
import script from "./SmsTemplateList.vue?vue&type=script&lang=js"
export * from "./SmsTemplateList.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateList.vue?vue&type=style&index=0&id=40fb1e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports